const codes = {
  failed: {
    code: 'failed',
    message: 'An error has occurred.'
  },
  receiver_account_invalid: {
    code: 'receiver_account_invalid',
    message: 'Receiver account is invalid.'
  },
  receiver_account_blocked: {
    code: 'receiver_account_blocked',
    message: 'Receiver account is blocked.'
  },
  receiver_account_closed: {
    code: 'receiver_account_closed',
    message: 'Receiver account is closed.'
  },
  receiver_account_limit_exceeded: {
    code: 'receiver_account_limit_exceeded',
    message: 'Receiver account limit exceeded.'
  },
  receiver_account_not_allowed_payment: {
    code: 'receiver_account_not_allowed_payment',
    message: 'Receiver account does not allow this type of payment.'
  },
  receiver_institution_failure: {
    code: 'receiver_institution_failure',
    message: 'Transaction aborted due to failure on receiver institution.'
  },
  receiver_institution_not_enabled: {
    code: 'receiver_institution_not_enabled',
    message: 'Receiver institution is not enabled within the payment system.'
  },
  receiver_tax_id_divergent: {
    code: 'receiver_tax_id_divergent',
    message: 'Receiver tax id is divergent with account tax id.'
  },
  receiver_institution_qrcode_rejected: {
    code: 'receiver_institution_qrcode_rejected',
    message: 'QR Code rejected by the receiver institution.'
  },
  antifraud_refused: {
    code: 'antifraud_refused',
    message: 'Transaction declined for security reasons. If you have any questions, please contact our support.'
  }
};

module.exports = codes;
